package ru.it_mozaika.sender.js.application.frames

import csstype.PropertiesBuilder
import mui.material.*
import mui.material.Box
import mui.material.styles.Theme
import mui.material.styles.create
import mui.material.styles.useTheme
import mui.system.Breakpoint
import mui.system.sx
import react.FC
import react.Props
import react.dom.html.ReactHTML
import react.router.Outlet
import react.useState
import web.cssom.Color
import web.cssom.px
import ru.it_mozaika.sender.js.application.components.Header
import ru.it_mozaika.sender.js.application.components.Sidebar

import web.cssom.*

val mainFrame = FC<Props> {
    val theme = useTheme<Theme>()
    val (drawerIsOpen, setDrawerIsOpen) = useState(true)
    Box {
        sx { display = Display.flex }
        CssBaseline()
        AppBar {
            enableColorOnDark = true
            position = AppBarPosition.fixed
            color = AppBarColor.inherit
            elevation = 0
            sx {
                backgroundColor = Color(theme.palette.background.default)
                transition = if (drawerIsOpen) theme.transitions.create("width") {} else None.none
                zIndex = integer(1_500)
            }
            Toolbar {
                Header {
                    onLeftDrawerToggle = {
                        setDrawerIsOpen { !it }
                    }
                }
            }
        }
        Sidebar {
            drawerOpen = drawerIsOpen
            drawerToggle = { setDrawerIsOpen { !it } }
        }
        Box {
            component = ReactHTML.main
            sx {
                +theme.typography.mainContent.unsafeCast<PropertiesBuilder>()
                backgroundColor = theme.palette.grey["100"].unsafeCast<Color>()
                borderBottomLeftRadius = 0.px
                borderBottomRightRadius = 0.px
                transition = theme.transitions.create("margin") {
                    if (drawerIsOpen) {
                        easing = theme.transitions.easing.easeOut
                        duration = theme.transitions.duration.enteringScreen
                    } else {
                        easing = theme.transitions.easing.sharp
                        duration = theme.transitions.duration.leavingScreen
                    }
                }
                (theme.breakpoints.up(Breakpoint.md)) {
                    marginLeft = if (drawerIsOpen) 0.px else (-240).px
                    width = 100.pct - 260.px
                }
                (theme.breakpoints.down(Breakpoint.md)) {
                    marginLeft = 20.px
                    width = 100.pct - 260.px
                    padding = 16.px
                }
                (theme.breakpoints.down(Breakpoint.sm)) {
                    marginLeft = 10.px
                    width = 100.pct - 260.px
                    padding = 16.px
                    marginRight = 10.px
                }
            }
            Outlet()
        }
    }
}